import styled from 'styled-components';

const RootStyles = styled.div``;

export default RootStyles;
